export enum ChannelType {
  PROGRAM = "program",
  PRIVATE = "messaging",
  BOX = "box",
}
